module.exports = __webpack_public_path__ + "media/newuservideoH5.01137c79.mp4";